import { Listbox } from '@headlessui/react';
import { Observation } from 'interfaces/observation';

interface Props {
  observation: Observation;
  onChange: (observation: Observation) => void;
}

const allStatusOptions = {
  success: {
    status: 'success',
    label: 'Success',
  },
  failure: {
    status: 'failure',
    label: 'Failure',
  },
  unknown: {
    status: 'unknown',
    label: 'Pending',
  },
  archived: {
    status: 'archived',
    label: 'Archived',
  },
};

const ObservationRow: React.FC<Props> = ({ observation, onChange }) => {
  const { description, source, status } = observation;
  const statusOptions = Object.values(allStatusOptions).filter(
    (option) => option.status !== status
  );
  let statusColor: string;
  switch (status) {
    case 'success':
      statusColor =
        'text-summer-green-700 bg-summer-green-100 border-summer-green-200 hover:bg-summer-green-200';
      break;
    case 'unknown':
      statusColor =
        'text-san-juan-blue-500 bg-new-orleans-400 border-new-orleans-500 hover:bg-new-orleans-500';
      break;
    case 'failure':
      statusColor =
        'text-apricot-700 bg-apricot-200 border-apricot-300 hover:bg-apricot-300';
      break;
    default:
      statusColor =
        'text-gray-800 bg-gray-100 border-gray-100 hover:bg-gray-200 focus:ring-gray-500 focus:border-gray-500';
  }

  const onChangeStatus = (status) => {
    onChange({
      ...observation,
      status,
    });
  };

  return (
    <div className="w-full py-6 pl-3 flex items-center justify-between">
      <div className="flex-1 truncate">
        <div className="flex items-center">
          <h3 className="text-sm pr-10 whitespace-pre-wrap font-medium text-gray-900 truncate">
            {description}
          </h3>
        </div>
        <p className="mt-2 text-sm leading-5 text-gray-500 truncate">
          Created by {source}
        </p>
      </div>
      <div className="relative">
        <Listbox value={status} onChange={onChangeStatus}>
          <Listbox.Button
            className={`mt-2 px-6 py-2 rounded-md shadow-sm text-center cursor-pointer focus:outline-none focus:ring-1 font-medium text-sm ${statusColor}`}
          >
            {allStatusOptions[status].label}
          </Listbox.Button>
          <Listbox.Options className="absolute z-10 mt-1 w-full cursor-pointer bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
            {statusOptions.map((option) => (
              <Listbox.Option
                key={option.status}
                value={option.status}
                className={({ active }) =>
                  `${
                    active ? 'bg-gray-100' : ''
                  } text-gray-900 select-none relative py-2 pl-3 pr-9`
                }
              >
                {option.label}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Listbox>
      </div>
    </div>
  );
};

export default ObservationRow;
